import EUserDirector from "../core/contracts/EUserDirector";
import EUserDirectorRequest from "../core/contracts/EUserDirectorRequest";
import BaseService from "./BaseService";

export default class DirectorService {
  async fetchAll() {
    try {
      const response = new BaseService(true).get("Director/ListarTodos");

      return response;
    } catch (error) {
      // eslint-disable-next-line no-console
    }
  }

  async save(params: EUserDirectorRequest[]): Promise<EUserDirector[]> {
    try {
      const action = await new BaseService(true).post<EUserDirectorRequest[], EUserDirector[]>(
        "UserDirector/AssociarUsuarioDiretoria",
        params
      );

      return action;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("DirectorService -> save -> error", error);
      return Promise.reject(error);
    }
  }
}
